export default __webpack_public_path__ + "static/2-a0e4a05361d21a4dd038900b06360068.jpg";